import { Container } from "react-bootstrap";

function Cancel() {
    return(
        <Container>
            <h1>Sorry to see you cancelled your Stripe payment</h1>
        </Container>
    )
}
export default Cancel; 